import {
    FormControl,
    FormLabel,
    Input
} from '@chakra-ui/react';
import { useForm } from '@dladio/hooks';
import _ from 'lodash';

export const Datafield = ({ field }: any) => {

    const { form, setForm, formController, clearForm } = useForm()
    const ishidden = _.isString(field.depends_on)

    return (
        <FormControl hidden={ishidden}>
            <FormLabel fontSize={'sm'} fontWeight={'light'}>{field.label}</FormLabel>
            <Input size={'sm'} rounded={'md'} type='email'
                name={field.fieldname} onChange={formController} value={_.get(form, field.fieldname) || ''}
            />
        </FormControl>
    )
}